import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { fetchCasinoGamesReport } from "./casinoGamesReportApi";

const queryKeyBase = ["casino", "gamesReport"];

/**
 * @param {Object} params
 * @param {string|undefined} params.start_date
 * @param {string|undefined} params.end_date
 * @param {number|undefined} [params.page]
 * @param {string|undefined} [params.search]
 * @param {string|undefined} [params.sort]
 * @param {string|undefined} [params.subprovider]
 * @param {string|undefined} [params.category]
 * @param {string[]|undefined} [params.money_type]
 * @param {Object} [options]
 * @param {boolean} [options.enabled]
 */
export function useCasinoGamesReport(params, options = {}) {
  const {
    start_date,
    end_date,
    page = 1,
    size = 20,
    search,
    sort,
    subprovider,
    category,
    money_type,
  } = params;
  const moneyTypeKey = money_type?.join(",") ?? "";

  return useQuery({
    queryKey: [
      ...queryKeyBase,
      start_date,
      end_date,
      page,
      size,
      search,
      sort ?? null,
      subprovider ?? null,
      category ?? null,
      moneyTypeKey,
    ],
    queryFn: () =>
      fetchCasinoGamesReport({
        start_date,
        end_date,
        page,
        size,
        ...(typeof search === "string" && search.trim() !== ""
          ? { search: search.trim() }
          : {}),
        ...(typeof sort === "string" && sort.trim() !== ""
          ? { sort: sort.trim() }
          : {}),
        ...(typeof subprovider === "string" && subprovider
          ? { subprovider }
          : {}),
        ...(typeof category === "string" && category
          ? { category }
          : {}),
        money_type,
      }),
    enabled: options.enabled !== false && Boolean(start_date && end_date),
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
  });
}
